import React from 'react'
import styles from './SearchHeader.module.css'
import SearchInput from '../SearchInput/SearchInput'

const SearchHeader = (props) => {
    return (
        <div className={styles.searchHeading}>
            <h1>{props.text}</h1>
            <SearchInput placeholder={props.placeholder} />
        </div>
    )
}

export default SearchHeader